// extracted by mini-css-extract-plugin
export default {"root":"ActionMenu_root__foK9X"};